// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-zxjfgl-jfcssz-index-main_right_content-3PCAR","table":"components-zxjfgl-jfcssz-index-table-2bhro","btn":"components-zxjfgl-jfcssz-index-btn-3SoEC"};


//////////////////
// WEBPACK FOOTER
// ./components/zxjfgl/jfcssz/index.css
// module id = 2335
// module chunks = 0